module.exports = __webpack_public_path__ + "img/d3.5e656126.svg";